var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgClock = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 23,
  height: 23,
  viewBox: "0 0 23 23"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 11.5,
  cy: 11.5,
  r: 11,
  stroke: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M18 12v-1h-7v1z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M12 12h-1V5h1z"
}))));
export default SvgClock;